class Dialog {

    constructor(scene, opts){

        if (!opts) opts = {};
        this.x = opts.x || 100;
        this.y = opts.y || 100;
        this.width = opts.width || 300;
        this.height = opts.height || 300;
        this.padding = opts.padding || 50;
        this.opacity = opts.padding || .75;

        this.titleText = opts.title || "Dialog Title";
        this.subTitleText = opts.subTitle || "Dialog subTitle";

        const container = scene.add.container(this.x, this.y);

        const doublePadding = this.padding*2;
        const textWrap = this.width - doublePadding;

        this.title = scene.add.text(this.padding, this.padding, this.titleText).setStyle({
            fontSize: '60px',
            fontFamily: '"Roboto Condensed"',
            wordWrap: {
                width: textWrap
            }
        });  

        var titleBackground = scene.add.rectangle(0, 0, doublePadding + this.title.displayWidth, doublePadding + this.title.displayHeight, '0xff00ff');
        titleBackground.setOrigin(0, 0);
        titleBackground.setAlpha(.75);

        this.subTitle = scene.add.text(this.padding, this.padding + titleBackground.displayHeight + 30, this.subTitleText).setStyle({
            fontSize: '40px',
            fontFamily: '"Roboto Condensed"',
            wordWrap: {
                width: textWrap
            }
        }); 

        var subTitleBackground = scene.add.rectangle(0, titleBackground.displayHeight + 30, doublePadding + this.subTitle.displayWidth, doublePadding + this.subTitle.displayHeight, '0xff00ff');
        subTitleBackground.setAlpha(.75);
        subTitleBackground.setOrigin(0, 0);

        container.add(titleBackground);
        container.add(subTitleBackground);
        container.add(this.title);
        container.add(this.subTitle);
 
    }

}

export default Dialog;